/**
 * ComputedAttributePage.jsx
 * Pagina de Cadastro/Edicao de Atributo Computado com Wizard Premium
 *
 * Rotas (padrao Traccar):
 *   /settings/attribute/computed      -> Criar novo
 *   /settings/attribute/computed/:id  -> Editar existente
 *
 * Nota: Arquivo original salvo em ComputedAttributePage.original.jsx
 */

import React, { useState, useEffect } from 'react';
import {
 Box, Typography, CircularProgress, Button 
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { usePremiumTokens } from '../common/theme/usePremiumTokens';
import { useTranslation } from '../common/components/LocalizationProvider';
import ComputedAttributeFormWizard from './components/ComputedAttributeFormWizard';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';

const ComputedAttributePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const t = useTranslation();
  const tokens = usePremiumTokens();

  const [computedAttribute, setComputedAttribute] = useState(null);
  const [loading, setLoading] = useState(!!id);
  const [error, setError] = useState(null);

  const colors = {
    accent: tokens?.accent?.primary || '#00d4aa',
    error: tokens?.semantic?.error || '#f85149',
    textSecondary: tokens?.text?.secondary || '#8b949e',
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      fetch(`/api/attributes/computed/${id}`)
        .then((res) => {
          if (!res.ok) throw new Error(t('wizardErrorNotFound') || 'Atributo nao encontrado');
          return res.json();
        })
        .then((data) => {
          setComputedAttribute(data);
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    }
  }, [id, t]);

  if (loading) {
    return (
      <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedComputedAttribute']}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <CircularProgress sx={{ color: colors.accent }} />
        </Box>
      </PageLayout>
    );
  }

  if (error) {
    return (
      <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedComputedAttribute']}>
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography sx={{ color: colors.error, mb: 2 }}>{error}</Typography>
          <Button
            variant="outlined"
            onClick={() => navigate('/settings/attributes/computed')}
            sx={{ color: colors.textSecondary, borderColor: colors.textSecondary }}
          >
            {t('sharedBack') || 'Voltar'}
          </Button>
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedComputedAttribute']}>
      <Box sx={{ p: { xs: 1, sm: 2 } }}>
        <ComputedAttributeFormWizard
          key={id || 'new'}
          computedAttribute={computedAttribute}
          onSave={() => navigate('/settings/attributes/computed')}
          onCancel={() => navigate('/settings/attributes/computed')}
        />
      </Box>
    </PageLayout>
  );
};

export default ComputedAttributePage;
